<template>
    <v-dialog v-model="visible" persistent :max-width="maxWidth">
        <v-card>
            <v-card-title
                    class="headline grey lighten-2"
                    primary-title
            >
                <template v-if="type === 'edit'">Upravit</template>
                <template v-if="type !== 'edit'">Vytvořit</template>
                {{title}}
            </v-card-title>
            <v-card-text>
                <v-form v-model="valid">
                    <v-container grid-list-md>
                        <v-layout row>
                            <v-flex xs12>
                                <div
                                        v-if="form.id > 0"
                                        class="text-lg-right mb-3"
                                >
                                    ID: {{form.id}}
                                </div>

                                <slot></slot>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </v-form>
            </v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text
                       @click="$emit('close')">
                    Zavřít
                </v-btn>

                <v-btn color="success"
                       text @click="$emit('process')"
                       :disabled="!valid"
                >
                    <template v-if="type === 'edit'">Uložit</template>
                    <template v-if="type !== 'edit'">Vytvořit</template>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            visible: Boolean,
            type: String,
            form: Object,
            title: String,
            maxWidth: {
                type: String,
                default: '400px'
            }
        },

        data: () => ({
            valid: false
        })
    }
</script>
